import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAxios } from "../hooks";

function useVisitorVerification() {
  const axios = useAxios();
  const { visitorData } = useSelector((state) => state.memberDetails);
  const sessionStorageToken = sessionStorage.getItem("authToken");

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const data = [];
      const visitorIds = [
        ...(visitorData?.dependentList?.map((d) => d._id) || []),
        ...(visitorData?.ID ? [visitorData.ID] : []),
      ];

      visitorIds.forEach((id) => {
        let faceData = "",
          docData = {};
        for (const key of Object.keys(localStorage)) {
          if (key.includes(id) && !key.includes("userPayload")) {
            faceData = localStorage.getItem(key);
          } else if (key.includes(id) && key.includes("userPayload")) {
            docData = JSON.parse(localStorage.getItem(key));
          }
        }

        data.push({
          visitor_id: id,
          face_data: faceData || "",
          doc_data: docData || "",
        });
        localStorage.setItem(window.btoa(id), faceData ? "true" : "false");
      });

      if (data.length > 0) {
        axios({
          url: `admin/profile/check-visitor-verification`,
          method: "POST",
          data,
          disableError: true,
          disableRedirect: true,
          customAuthToken: sessionStorageToken,
        });
      }
    }, 75);

    return () => clearTimeout(timeoutId);
  });
}

export default useVisitorVerification;
